import { render, staticRenderFns } from "./CatalogWordpressCourses.vue?vue&type=template&id=d447d114"
import script from "./CatalogWordpressCourses.vue?vue&type=script&lang=js"
export * from "./CatalogWordpressCourses.vue?vue&type=script&lang=js"
import style0 from "./CatalogWordpressCourses.vue?vue&type=style&index=0&id=d447d114&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports